import "core-js/modules/es.function.name";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import DateSearch from './DateSearch.vue';
import FuzzySearch from './FuzzySearch.vue';

var DocumentManage = /*#__PURE__*/function (_Vue) {
  _inherits(DocumentManage, _Vue);

  var _super = _createSuper(DocumentManage);

  function DocumentManage() {
    var _this;

    _classCallCheck(this, DocumentManage);

    _this = _super.apply(this, arguments);
    _this.activeName = 'fuzzy';
    _this.component = 'FuzzySearch';
    return _this;
  }

  _createClass(DocumentManage, [{
    key: "handleClick",
    value: function handleClick(val) {
      this.component = val.name === 'fuzzy' ? 'FuzzySearch' : 'DateSearch';
    }
  }]);

  return DocumentManage;
}(Vue);

DocumentManage = __decorate([Component({
  components: {
    DateSearch: DateSearch,
    FuzzySearch: FuzzySearch
  }
})], DocumentManage);
export default DocumentManage;